import { render, staticRenderFns } from "./link-report.vue?vue&type=template&id=6e19bcbc&scoped=true&"
import script from "./link-report.vue?vue&type=script&lang=js&"
export * from "./link-report.vue?vue&type=script&lang=js&"
import style0 from "./link-report.vue?vue&type=style&index=0&id=6e19bcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19bcbc",
  null
  
)

export default component.exports